import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { FlowAuditListComponent } from '../../components/flow-audit-list/flow-audit-list.component';

@Component({
  selector: 'app-flow-audit-history',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, FlowAuditListComponent],
  templateUrl: './flow-audit-history.component.html',
  styleUrl: './flow-audit-history.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FlowAuditHistoryComponent {
  readonly appSettings = inject(AppSettings);
  private readonly router = inject(Router);

  closeModule(): void {
    void this.router.navigate(['/configuracion/flujos']);
  }
}
